module.exports = __webpack_public_path__ + "static/media/sample_lmroute_config.ef71e45d.csv";